/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Img from 'react-image';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import jump from 'jump.js';
import { Link } from '@reach/router';

import { history } from '../../utils/router-history';

import Logo from '../../img/logo-blanco.png';
import styles from './index.module.scss';
let cx = classNames.bind(styles);

const Footer = props => {
	const { t } = useTranslation();

	let navMenuClass = classNames({
		'cursor-pointer menu-items text-base font-bold inline-block no-underline py-2 px-3 font-medium': true,
	});

	const navigateTo = section => {
		debugger;
		console.log({ section });
		if (props.page && props.page === 'home') {
			jump(`section#${section}`, {
				offset: -90,
				duration: 1000,
			});
		} else {
			navigateToHome(section);
		}
	};

	const navigateToHome = section => {
		history.navigate('/#' + section, { replace: true });
	};

	return (
		<footer className={cx({ footer: true, 'bg-ccu-green': true })}>
			<div className='container mx-auto py-10'>
				<div className='w-full flex flex-col lg:flex-row'>
					<div className='w-full lg:w-3/12 flex text-base flex-row items-center justify-center lg:justify-start'>
						<a
							className='text-orange-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl'
							href='/'
						>
							<Img className={cx({ logo: true })} src={Logo} alt='Logo' />
						</a>
					</div>
					<div className='w-full lg:w-9/12 flex text-base flex-row items-end justify-end lg:justify-end'>
						<ul className='list-reset hidden lg:flex justify-end flex-1 items-center'>
							<li className='mr-2'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => navigateTo('nosotros')}
								>
									<p>{t('layout.menu.we')}</p>
								</span>
							</li>
							<li className='mr-2'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => navigateTo('principios')}
								>
									<p>{t('layout.menu.values')}</p>
								</span>
							</li>
							<li className='mr-2'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => navigateTo('areas')}
								>
									<p>{t('layout.menu.areas')}</p>
								</span>
							</li>
							<li className='mr-2'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => navigateTo('marcas')}
								>
									<p>{t('layout.menu.trademarks')}</p>
								</span>
							</li>
							<li className='mr-2'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => navigateTo('sustentabilidad')}
								>
									<p>{t('layout.menu.sutentability')}</p>
								</span>
							</li>
							{/* <li className='mr-2'>
								<span
									className={navMenuClass}
									href='#'
									onClick={() => navigateTo('experiencia')}
								>
									<p>{t('layout.menu.experience')}</p>
								</span>
							</li> */}
							<li className='mr-2'>
							<a
								id='navAction'
								href='https://postulacionesccuargentina.hiperjob.com/ofertas'
								target='_blank'
								rel='noopener noreferrer'
								className={navMenuClass}
							>
								{t('layout.menu.opportunities')}
							</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className='container pb-5 mx-auto'>
				<div className='w-full flex flex-row justify-center lg:justify-end'>
					<a className='mr-4' href="https://www.linkedin.com/company/companiacerveceriasunidas/" target="_blank">
						<i className="fab fa-linkedin text-4xl"></i>
					</a>
					<a className='mr-4' href="https://www.instagram.com/ccu.argentina/" target="_blank">
						<i className="fab fa-instagram text-4xl"></i>
					</a>
					<a className='mr-4' href="https://www.facebook.com/ccuarg" target="_blank">
						<i className="fab fa-facebook-square text-4xl"></i>
					</a>
					<a className='mr-4' href="https://www.youtube.com/@ccuargentinaoficial" target="_blank">
						<i className="fab fa-youtube text-4xl"></i>
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
